export abstract class BaseModel {

    TenantID: number;
    CreatedOnDate?: Date;
    CreatedByUserID: number;
    UpdatedOnDate?: Date;
    UpdatedByUserID: number;

}